"use client";

import { cn } from "@ui/lib";

interface YouTubeEmbedProps {
	videoId: string;
	title?: string;
	className?: string;
	aspectRatio?: "16/9" | "4/3";
	autoplay?: boolean;
	controls?: boolean;
	modestBranding?: boolean;
	showRelated?: boolean;
	startTime?: number;
}

export function YouTubeEmbed({
	videoId,
	title = "YouTube video",
	className,
	aspectRatio = "16/9",
	autoplay = false,
	controls = true,
	modestBranding = true,
	showRelated = false,
	startTime,
}: YouTubeEmbedProps) {
	// Build YouTube URL with parameters
	const params = new URLSearchParams({
		rel: showRelated ? "1" : "0",
		modestbranding: modestBranding ? "1" : "0",
		controls: controls ? "1" : "0",
		autoplay: autoplay ? "1" : "0",
		...(startTime && { start: startTime.toString() }),
	});

	const embedUrl = `https://www.youtube.com/embed/${videoId}?${params.toString()}`;

	return (
		<div className={cn("not-prose my-8", className)}>
			<div
				className={cn(
					"relative overflow-hidden rounded-lg border bg-card shadow-sm",
					aspectRatio === "16/9" && "aspect-video",
					aspectRatio === "4/3" && "aspect-[4/3]"
				)}
			>
				<iframe
					src={embedUrl}
					title={title}
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowFullScreen
					className="absolute inset-0 h-full w-full"
					loading="lazy"
				/>
			</div>
		</div>
	);
}
